/* ============================================================
   CTS CONTACT FORM DRAWER
   Load via theme.liquid:  {{ "cts-rfq.js" | asset_url | script_tag }}
   ------------------------------------------------------------
   Builds the "Contact Form" side drawer, moves the native Shopify
   contact form (snippets/cts-rfq-form.liquid) into it, and opens /
   closes it from any element with data-quote-toggle (the header's
   Contact Us links). Slides in from the right on desktop and up
   from the bottom on mobile (see cts-rfq.css).

   The old quote list, quote PDF and Add to Quote code was removed
   on Oct 20, 2026. The cart PDF lives in cts-cart-pdf.js.

   Public API (kept for anything that still calls it):
     - window.QuoteRFQ.open()    open the drawer
     - window.QuoteRFQ.close()   close the drawer
   ============================================================ */
(function () {
  'use strict';

  // Storage key used by the old quote list. Cleared once on load so
  // returning visitors don't keep stale data in their browser.
  var OLD_STORAGE_KEY = 'cts_quote_items_v1';

  var QuoteRFQ = {

    /* ---------- drawer open/close ---------- */
    open: function () {
      var root = document.getElementById('cts-rfq-drawer');
      if (!root) return;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cts-rfq-open');
      this.render();
    },
    close: function () {
      var root = document.getElementById('cts-rfq-drawer');
      if (!root) return;
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('cts-rfq-open');
    },

    /* ---------- form tweaks ---------- */
    render: function () {
      // Contact form: the Message field is always required.
      var msg = document.getElementById('cts-rfq-message');
      var msgLabel = document.querySelector('label[for="cts-rfq-message"]');
      if (msg && !msg.getAttribute('required')) {
        msg.setAttribute('required', 'required');
        if (msgLabel && msgLabel.innerHTML.indexOf('cts-rfq-req') === -1) {
          msgLabel.innerHTML = 'Message<span class="cts-rfq-req">*</span>';
        }
      }
    },

    /* ---------- relocate the native Shopify form into the drawer ---------- */
    attachForm: function (attempt) {
      var self = this;
      var region = document.getElementById('cts-rfq-form-region');
      if (!region) return;

      // Already attached?
      if (region.querySelector('.cts-rfq-form-wrap')) return;

      var host = document.getElementById('cts-rfq-form-host');
      var formWrap = host ? host.querySelector('.cts-rfq-form-wrap') : null;

      if (!formWrap) {
        // Host may not be in the DOM yet (snippet renders later in the page).
        attempt = attempt || 0;
        if (attempt < 20) {
          setTimeout(function () { self.attachForm(attempt + 1); }, 150);
        } else {
          console.warn('[Contact form] form host not found. Did you add {% render "cts-rfq-form" %} to theme.liquid?');
        }
        return;
      }

      // Move it in and make sure it is visible (host parent was hidden).
      region.appendChild(formWrap);
      formWrap.removeAttribute('hidden');
      formWrap.style.display = 'block';

      var formEl = region.querySelector('form');
      if (formEl) {
        formEl.addEventListener('submit', function () {
          // Mark that this form was submitted, so the success message shows
          // only after a real submit. The native submission then proceeds.
          try { sessionStorage.setItem('cts_rfq_just_submitted', '1'); } catch (err) {}
        });
      }
    },

    /* ---------- build the drawer shell once ---------- */
    mount: function () {
      if (document.getElementById('cts-rfq-drawer')) return;
      var wrap = document.createElement('div');
      wrap.id = 'cts-rfq-drawer';
      wrap.className = 'cts-rfq-drawer';
      wrap.setAttribute('aria-hidden', 'true');
      wrap.innerHTML = '' +
        '<div class="cts-rfq-overlay" data-action="close"></div>' +
        '<aside class="cts-rfq-panel" role="dialog" aria-label="Contact Us">' +
          '<header class="cts-rfq-header">' +
            '<span class="cts-rfq-title">Contact Form</span>' +
            '<button type="button" class="cts-rfq-close" data-action="close" aria-label="Close">' +
              '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M18 6 6 18M6 6l12 12"/></svg>' +
            '</button>' +
          '</header>' +
          '<div class="cts-rfq-body" id="cts-rfq-body">' +
            '<div id="cts-rfq-form-region"></div>' +
          '</div>' +
        '</aside>';
      document.body.appendChild(wrap);

      this.attachForm();

      var self = this;

      // Overlay and X button close the drawer
      wrap.addEventListener('click', function (e) {
        var actionEl = e.target.closest('[data-action="close"]');
        if (actionEl) self.close();
      });

      // Esc closes
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') self.close();
      });
    },

    /* ---------- wire the header Contact Us link(s) ---------- */
    bindHeaderButtons: function () {
      var self = this;
      document.addEventListener('click', function (e) {
        var toggle = e.target.closest('[data-quote-toggle]');
        if (!toggle) return;
        e.preventDefault();
        var root = document.getElementById('cts-rfq-drawer');
        if (root && root.classList.contains('is-open')) {
          self.close();
        } else {
          self.open();
        }
      });
    },

    /* ---------- init ---------- */
    init: function () {
      try { localStorage.removeItem(OLD_STORAGE_KEY); } catch (err) {}

      this.mount();
      this.bindHeaderButtons();
      this.render();

      // The success message is server-rendered when posted_successfully? is
      // true, but that can read true on plain loads when a contact form
      // exists site-wide. A one-shot sessionStorage flag set at submit time
      // makes the message show exactly once, only after a real submit.
      var successMsg = document.getElementById('cts-rfq-form-success');
      var justSubmitted = false;
      try { justSubmitted = sessionStorage.getItem('cts_rfq_just_submitted') === '1'; } catch (err) {}

      if (successMsg && justSubmitted) {
        // Consume the flag so a later reload won't show it again
        try { sessionStorage.removeItem('cts_rfq_just_submitted'); } catch (err) {}
        this.open();

        var closeBtn = document.getElementById('cts-rfq-success-close');
        if (closeBtn) {
          closeBtn.addEventListener('click', function () {
            if (successMsg.parentNode) successMsg.parentNode.removeChild(successMsg);
          });
        }
      } else if (successMsg) {
        // Server rendered it but this wasn't a fresh submit: remove the
        // stray message so it never shows on normal page loads.
        if (successMsg.parentNode) successMsg.parentNode.removeChild(successMsg);
      }
    }
  };

  window.QuoteRFQ = QuoteRFQ;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { QuoteRFQ.init(); });
  } else {
    QuoteRFQ.init();
  }
})();